import React from 'react';

const AbacusContext = React.createContext({});

export default AbacusContext;



// WEBPACK FOOTER //
// ./src/universal/abacus/abacus-context.js